import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  stepperContainer: {
    width: "100%",
    position: "relative",
  },
  procesoIdentificador: {
    position: "absolute",
    right: 1,
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: "text.secondary",
    opacity: 0.8,
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
  },
  backButton: {
    marginRight: "8px",
  },
  skipButton: {
    marginRight: "8px",
  },
}));
